export function initUserlikeManipulation() {
    const footer = document.querySelector('.footer');

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const element = document.querySelector('[data-test-id="userlike-container"]');
            if(!element) return;
            if (entry.isIntersecting) {
                element.classList.add('hide-userlike');
            } else {
                element.classList.remove('hide-userlike');

            }
        });
    }, { threshold: 0.1 });

    observer.observe(footer);
}